export default "__VITE_ASSET__DYD9GUQA__"